import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Tooltip, Badge } from "@material-ui/core";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  iconButtonBase: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "50%",
    padding: 4,
    margin: "0 4px",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    boxShadow:
      theme.mode === "light"
        ? "0 2px 4px rgba(0,0,0,0.1)"
        : "0 2px 4px rgba(255,255,255,0.1)",
  },
  iconStyle: {
    width: 20,
    height: 20,
    color: (props) => props.iconColor || theme.palette.action.active,
  },
  hoverState: {
    "& svg": {
      color: `${theme.palette.primary.main} !important`,
    },
    backgroundColor: `${theme.palette.action.hover} !important`,
  },
  selectedState: {
    "& svg": {
      color: `${theme.palette.primary.main} !important`,
    },
    backgroundColor: `${theme.palette.action.selected} !important`,
    "&:hover": {
      backgroundColor: `${theme.palette.action.hover} !important`,
    },
  },
}));

const IconButtonWithTooltip = ({
  icon: IconComponent,
  tooltip,
  onClick,
  iconColor,
  badgeProps,
  className,
  isHovered,
  isSelected,
  ...props
}) => {
  const classes = useStyles({ iconColor });

  const iconElement = React.createElement(IconComponent, {
    className: classes.iconStyle,
  });

  const buttonContent = badgeProps ? (
    <Badge {...badgeProps}>{iconElement}</Badge>
  ) : (
    iconElement
  );

  const buttonClassName = clsx(
    classes.iconButtonBase,
    isHovered && classes.hoverState,
    isSelected && classes.selectedState,
    className
  );

  return (
    <Tooltip title={tooltip || ""} arrow>
      <IconButton
        edge="start"
        onClick={onClick}
        className={buttonClassName}
        size="small"
        {...props}
      >
        {buttonContent}
      </IconButton>
    </Tooltip>
  );
};

export default IconButtonWithTooltip;
